import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "../shared/layouts/admin-layout/admin-layout.component";
import { LoginComponent } from "../features/account/login/login.component";
import { ForgotComponent } from "../features/account/forgot/forgot.component";
import { DashboardComponent } from "../features/admin/dashboard/dashboard.component";
import { UsersComponent } from "../features/admin/users/users.component";
import { PartnersComponent } from "../features/admin/partners/partners.component";
import { SettingsComponent } from "../features/admin/settings/settings.component";
import { ResetPasswordComponent } from "../features/account/reset-password/reset-password.component";
import { ProfileDetailComponent } from "../features/app/profile-detail/profile-detail.component";
import { LoggerComponent } from "../features/admin/logger/logger.component";
import { VoilationReportsComponent } from "../features/admin/voilation-reports/voilation-reports.component";
import { adminGuard, redirectIfAuthenticated, resetAccessGuard } from "../Utils/_guards/auth.guard";
import { PrivacyPolicyComponent } from "../features/app/privacy-policy/privacy-policy.component";
import { TermsOfServicesComponent } from "../features/app/terms-of-services/terms-of-services.component";
import { CookiePoliciesComponent } from "../features/app/cookie-policies/cookie-policies.component";
// import { VerificationRequestsComponent } from "../features/admin/verification-requests/verification-requests.component";
import { PaymentTransactionsComponent } from "../features/admin/payment-transactions/payment-transactions.component";
import { WaitlistedUserComponent } from "../features/admin/waitlisted-user/waitlisted-user.component";
import { EventsComponent } from "../features/admin/events/events.component";
import { EventDetailComponent } from "../features/admin/events/event-detail/event-detail.component";
import { NotificationManagementComponent } from "../features/admin/notification-management/notification-management.component";
import { SubscriptionManagementComponent } from "../features/admin/subscription-management/subscription-management.component";
import { LandingPageComponent } from "../features/main-landing-page/landing-page.component";
import { SafetyPolicyComponent } from "../features/app/safety-policy/safety-policy.component";
import { WaitlistComponent } from "../features/app/comming-soon/waitlist.component";
import { VerifyCodeComponent } from "../features/account/verify-code/verify-code.component";
import { OnboardingImagesComponent } from "../features/admin/onboarding-images/onboarding-images.component";
import { VerificationRequestsComponent } from "../features/admin/verification-requests/verification-requests.component";
import { UserDetailComponent } from "../features/admin/users/user-detail/user-detail.component";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: LandingPageComponent,
    // component: WaitlistComponent,
    //  component: ComingSoonComponent,
    // component: WaitlistComponent,
  },
  {
    path: "admin",
    component: AdminLayoutComponent,
    canActivate: [adminGuard],
    children: [
      { path: "", component: DashboardComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "users", component: UsersComponent },
      { path: "users/:id", component: UserDetailComponent },
      { path: "verification-requests", component: VerificationRequestsComponent },
      { path: "partners", component: PartnersComponent },
      { path: "payment-transactions", component: PaymentTransactionsComponent },
      { path: "settings", component: SettingsComponent },
      { path: "profile", component: ProfileDetailComponent },
      { path: 'logs', component: LoggerComponent },
      { path: 'violation-report', component: VoilationReportsComponent },
      { path: 'waitlisted-user', component: WaitlistedUserComponent},
      { path: 'notification-management', component: NotificationManagementComponent },
      { path: 'brand-images', component: OnboardingImagesComponent },
      { path: 'subscription-management', component : SubscriptionManagementComponent},
      { path: 'events', component: EventsComponent },
      { path: 'events/:id', component: EventDetailComponent },
    ],
  },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  { path: "terms-of-services", component: TermsOfServicesComponent },
  { path: "cookie-policy", component: CookiePoliciesComponent },
  { path: "safety-policy", component: SafetyPolicyComponent },
  {
    path: "auth",
    canActivate: [redirectIfAuthenticated],
    children: [
      { path: "", redirectTo: "login", pathMatch: "full" },
      { path: "login", component: LoginComponent },
      { path: "forgot-password", component: ForgotComponent },
      { path: "forgot-password-otp", component: VerifyCodeComponent },
      { path: "admin-verify-otp", component: VerifyCodeComponent, data: { mode: 'admin-verify' } },
      { path: "reset-password", component: ResetPasswordComponent, canActivate: [resetAccessGuard] }
    ]
  },
  { path: "**", redirectTo: "" },
];
